import React, { useMemo } from 'react';
import styles from './Tags.module.scss';
import { mergeTagCategories } from './mergeTagCategories';

/**
 * Shows a list of tags separated by categories
 *
 * Expects categories defined as
 *      categories: [
 *          {name: 'Category 1', options: [
 *              { name: 'Tag 1.1', color: '#fff' },
 *              ...
 *          ]},
 *          ...
 *      ]
 * Tags expected as as
 *      tags: {
 *          'Category 1': ['Tag 1.1', 'Tag 1.2', ...],
 *          ...
 *      }
 *
 * @param {string}  className           Classname to add to the toplevel dom element
 * @param {object}  props               Properties
 * @param {array}   props.categories    List of categories
 * @param {object}  props.tags          Tags for the displayed item
 * @returns Component
 */
function Tags(props) {
    const { className = '', categories = [], tags = {} } = props,
        merged = useMemo(() => mergeTagCategories(categories, tags, true), [categories, tags]);

    return (
        <ul className={[className, styles.categoriesList].join(' ')}>
            {merged
                .filter((category) => category.options.length)
                .map((category, i) => (
                    <li key={i}>
                        {category.name}
                        <ul>
                            {category.options.map((option, j) => (
                                <li
                                    key={j}
                                    style={{
                                        backgroundColor: option.color,
                                    }}>
                                    {option.name}
                                </li>
                            ))}
                        </ul>
                    </li>
                ))}
        </ul>
    );
}

export default Tags;
